import { Controller } from "@hotwired/stimulus";
import { create as createWebAuthnJSON, get as getWebAuthnJSON } from "@github/webauthn-json";

export default class extends Controller {
  static targets = ["credentialHiddenInput", "submitButton"];
  static values = { optionsUrl: String }

  connect() {
    this.submitButtonTarget.disabled = false;

    // Debug: Check if WebAuthn library is loaded
    console.log("WebAuthn controller connected");
    console.log("createWebAuthnJSON:", typeof createWebAuthnJSON);
    console.log("getWebAuthnJSON:", typeof getWebAuthnJSON);
    console.log("PublicKeyCredential:", typeof window.PublicKeyCredential);
    console.log("navigator.credentials:", typeof window.navigator?.credentials);
    console.log("User Agent:", navigator.userAgent);
  }

  async create() {
    try {
      // Check if WebAuthn is supported
      if (!window.PublicKeyCredential) {
        throw new Error("WebAuthn is not supported in this browser");
      }

      // Check if the library is loaded
      if (typeof createWebAuthnJSON === 'undefined') {
        throw new Error("WebAuthn library not loaded properly");
      }

      const optionsResponse = await fetch(this.optionsUrlValue, {
        method: "POST",
        body: new FormData(this.element),
        headers: {
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.getAttribute("content")
        },
      });

      const optionsJson = await optionsResponse.json();
      if (optionsResponse.ok) {
      // Debug: Log the response to see what we're getting
      console.log("WebAuthn create options response:", optionsJson);
      console.log("createWebAuthnJSON function:", typeof createWebAuthnJSON);
      console.log("createWebAuthnJSON function details:", createWebAuthnJSON);

      // Check if the response has the expected structure
      if (!optionsJson.challenge) {
        throw new Error("Invalid WebAuthn options: missing challenge");
      }

      // Debug: Log the options being passed
      console.log("About to call createWebAuthnJSON with:", { publicKey: optionsJson });

      // Use the correct API for @github/webauthn-json v2.1.1
      const credential = await createWebAuthnJSON({ publicKey: optionsJson });

        this.credentialHiddenInputTarget.value = JSON.stringify(credential);

        this.element.submit();
      } else {
        alert(optionsJson.errors?.[0] || "Unknown error");
      }
    } catch (error) {
      console.error("WebAuthn create error:", error);
      console.error("Error details:", {
        message: error.message,
        stack: error.stack,
        userAgent: navigator.userAgent
      });
      alert(`WebAuthn Error: ${error.message}`);
    }
  }

  async get() {
    try {
      // Check if WebAuthn is supported
      if (!window.PublicKeyCredential) {
        throw new Error("WebAuthn is not supported in this browser");
      }

      // Check if the library is loaded
      if (typeof getWebAuthnJSON === 'undefined') {
        throw new Error("WebAuthn library not loaded properly");
      }

      const optionsResponse = await fetch(this.optionsUrlValue, {
        method: "POST",
        body: new FormData(this.element),
        headers: {
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.getAttribute("content")
        },
      });

      const optionsJson = await optionsResponse.json();

      if (optionsResponse.ok) {
        // Debug: Log the response to see what we're getting
        console.log("WebAuthn get options response:", optionsJson);

        // Check if the response has the expected structure
        if (!optionsJson.challenge) {
          throw new Error("Invalid WebAuthn options: missing challenge");
        }

        // Use the correct API for @github/webauthn-json v2.1.1
        const credential = await getWebAuthnJSON({ publicKey: optionsJson });

        this.credentialHiddenInputTarget.value = JSON.stringify(credential);

        this.element.submit();
      } else {
        alert(optionsJson.errors?.[0] || "Unknown error");
      }
    } catch (error) {
      console.error("WebAuthn get error:", error);
      alert(`WebAuthn Error: ${error.message}`);
    }
  }

}
